import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./components/LoginPage"; // Головна сторінка входу
import ProjectList from "./components/ProjectList"; // Список проєктів
import CreateProject from "./components/CreateProject"; // Створення проєкту
import MyProjects from "./components/MyProjects"; // Мої проєкти
import About from "./components/About"; // Про платформу
import EditProject from "./components/EditProject"; // Редагування проєкту
import { ProjectProvider } from "./contexts/Project";

const App = () => {
  const [user, setUser] = useState(null); // Стан для збереження інформації про користувача

  return (
    <Router>
      <ProjectProvider>
        <Routes>
          <Route path="/" element={<LoginPage setUser={setUser} />} />
          <Route
            path="/projects"
            element={<ProjectList user={user} setUser={setUser} />}
          />
          <Route
            path="/create"
            element={<CreateProject user={user} setUser={setUser} />}
          />
          <Route
            path="/my-projects"
            element={<MyProjects user={user} setUser={setUser} />}
          />
          <Route
            path="/about"
            element={<About user={user} setUser={setUser} />}
          />
          <Route
            path="/edit/:id"
            element={<EditProject user={user} setUser={setUser} />}
          />
        </Routes>
      </ProjectProvider>
    </Router>
  );
};

export default App;
